import type { RouteObject } from 'react-router-dom'
import AdminWaitlist from '@/pages/AdminWaitlist'
import Home from '@/pages/Home'
import LoadingLanding from '@/pages/LoadingLanding'
import { useRoutes } from 'react-router-dom'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <LoadingLanding /> },
  { path: '/waitlist', element: <Home /> },
  { path: '/admin', element: <AdminWaitlist /> },
]

function App() {
  return useRoutes(routes)
}

export default App
